<!--
  - Copyright (c) 2023-2025. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('voucher') }}
    </page-header>
    <loading-provider :loading="loading">
      <v-container>
        <div
          style="display: grid; grid-template-columns: repeat(auto-fill,minmax(250px,1fr)); grid-gap: 24px"
        >
          <v-card
            class="pa-4 d-flex align-center justify-center"
            color="#eee"
            elevation="0"
            height="320"
            @click="startEditCoupon(-1)"
          >
            <div class="text-center">
              <v-icon size="48">
                mdi-plus
              </v-icon>
              <div>
                {{ $t('addNewVouchers') }}
              </div>
            </div>
          </v-card>
          <coupon-info-card
            v-for="(c,i) in couponList"
            :key="c.dishId"
            :coupon-info="c"
            @click="startEditCoupon(i)"
            @delete="deleteAndReload(c.dishId)"
          />
        </div>
        <ik-entity-form
          v-model="showEditCouponDialog"
          :edited-index="activeCouponIndex"
          :model="CouponModel"
          :title="$t('editVouchers')"
        />
      </v-container>
    </loading-provider>
  </div>
</template>

<script>
import CouponInfoCard from '@/views/AadenPages/billAndReport/customer/CouponInfoCard'
import PageHeader from '@/views/widget/typography/PageHeader'
import Coupon from '@/model/dataLayer/api/bills/Coupon'
import MemberCardRecord from '@/model/dataLayer/api/bills/CouponSalesRecord'
import { today } from '@/model/dataLayer/api/common/DateRepository'
import { mapMutations } from 'vuex'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'
import LoadingProvider from '@/views/widget/LoadingProvider'

export default {
  components: {
    LoadingProvider,
    CouponInfoCard,
    PageHeader,
    IkEntityForm
  },
  data () {
    return {
      activeCouponIndex: null,
      couponList: [],
      CouponModel: Coupon,
      model: MemberCardRecord,
      couponDetail: null,
      loading: false,
      showCouponDetailDialog: null,
      dates: [today, today],
      showEditCouponDialog: null,
      showDetail: null,
      currentOrderId: null
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    ...mapMutations(['showBillDetail']),
    async deleteAndReload (dishId) {
      await Coupon.remove(dishId)
      await this.reload()
    },
    showOrder (orderId) {
      this.showBillDetail(orderId)
    },
    async startEditCoupon (index) {
      this.activeCouponIndex = index
      // this.editObject = Object.assign({}, this.editObject, item)
      //
      // const store = useBaseFormDialogStore()

      // Define the schema for the redemption code dialog
      // const schema = {
      //   title: '创建兑换码',
      //   subtitle: `为 ${item.name || '资产'} 创建兑换码`,
      //   schemas: this.redemptionCodeSchemas
      // }
      //
      // // Open the dialog and wait for the result
      // const result = await store.editItem(schema)
      //
      // // Handle the result
      // if (result) {
      //   await this.saveRedemption(result)
      // }
    },
    async reload () {
      this.loading = true
      this.couponList = (await Coupon.getList(true)).filter(it => it.code !== 'gk' && it.code !== 'gel')
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
